import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "../styles/common/Footer.scss";
import { Col, Container, Row } from "react-bootstrap";
import {
  BsFacebook,
  BsInstagram,
  BsYoutube,
  BsBehance,
  BsLinkedin,
} from "react-icons/bs";
import { IoMdDownload } from "react-icons/io";
import brandLogo from "../assets/images/brandLogo.png";
import { Link } from "react-router-dom";
const Footer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Container fluid className="p-0 footer-container">
      <Container className="footer">
        <Row>
          <Col md={4} className="py-2 px-0">
            <div className="social-media-icons">
              <div className="social-icon">
                <BsFacebook />
              </div>
              <div className="social-icon">
                <BsInstagram />
              </div>
              <div className="social-icon">
                <BsYoutube />
              </div>
              <div className="social-icon">
                <BsBehance />
              </div>
              <div className="social-icon">
                <BsLinkedin />
              </div>
            </div>
          </Col>
          <Col md={4} className="text-center">
            <img src={brandLogo} alt="img" className="img-fluid" />
            <p className="copy-right-text">
              <span className="copy-right-sign">©</span>All right reserve to
              Mezro Ltd. 2022
            </p>
          </Col>
          <Col md={4}>
            <div className="footer-links">
              <Link to="contact">
                <a className="footer-item-link">Contact</a>
              </Link>
              {/* Resources Bottom Sheet start*/}
              <a className="footer-item-link bottom-sheet" onClick={handleShow}>
                Resources
              </a>
              <Offcanvas
                show={show}
                onHide={handleClose}
                placement={"bottom"}
                className="resources-bottom-sheet-bg offcanvas-height h-auto"
              >
                <Offcanvas.Header closeButton>
                  <h1 className="title resources-title">Resources</h1>
                </Offcanvas.Header>
                <div className="d-flex justify-content-between align-items-center container hr">
                  <h3 className="bottom-sheet-title">Company Profile</h3>
                  <a href="/images/myw3schoolsimage.jpg" download>
                    <IoMdDownload />
                  </a>
                </div>
                <div className="d-flex justify-content-between align-items-center container hr">
                  <h3 className="bottom-sheet-title">Letter Head</h3>
                  <a href="/images/myw3schoolsimage.jpg" download>
                    <IoMdDownload />
                  </a>
                </div>
                <div className="d-flex justify-content-between align-items-center container hr">
                  <h3 className="bottom-sheet-title">Company Profile</h3>
                  <a href="/images/myw3schoolsimage.jpg" download>
                    <IoMdDownload />
                  </a>
                </div>
                <div className="d-flex justify-content-between align-items-center container hr">
                  <h3 className="bottom-sheet-title">Company Profile</h3>
                  <a href="/images/myw3schoolsimage.jpg" download>
                    <IoMdDownload />
                  </a>
                </div>
              </Offcanvas>
              {/* Resources Bottom Sheet end*/}
              <Link to="career">
                <a className="footer-item-link">Career</a>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
